import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const workflowRequests = {}

workflowRequests.GetResourceData = (pdfName) => {
    return axios.post(
      AppUrls.CheckAcceptanceCfg,
      Config.SetParameters(pdfName, '', '', ''),
      Config.ConfigAuth()
    ).then(handleResponse)
}

workflowRequests.GetWorkflowDefinitions = (data) => {
  return axios.post(
    AppUrls.GetWorkFlowDefinitions,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
    ).then(handleResponse)
}

workflowRequests.ContinueWorkflow = (data) => {
  return axios.post(
    AppUrls.ContinueWorkflowApi,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
    ).then(handleResponse)
}

workflowRequests.CancelWorkFlow = (data) => {
  return axios.post(
    AppUrls.CancelWorkFlow,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
    ).then(handleResponse)
}

workflowRequests.GetWorkFlowDefinition = (data) => {
  return axios.post(
    AppUrls.GetWorkFlowDefinition,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
    ).then(handleResponse)
}

workflowRequests.GetBinnacle = (data) => {
  return axios.post(
    AppUrls.GetBinnacle,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
    ).then(handleResponse)
}

workflowRequests.RegisterStatusStage = (data) => {
  return axios.post(
    AppUrls.RegisterStatusStage,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
    ).then(handleResponse)
}

let handleResponse = (response) => {
  console.log('response', response)
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}
